import * as React from 'react';
import { useGetLocationQuery } from "../../../apis/Location.api";
import { PrimaryLocation, Location } from "../../../types/models/Location";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: Location;
};

export const LocationNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.hierarchyName }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const LocationName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetLocationQuery(PrimaryLocation.fromId(id))
    return (<LocationNameDisplay data={data}/>)
}

export default LocationName;
